





// import React, { useEffect, useRef, useState, useContext } from "react";
// import { Link, useHistory } from "react-router-dom";
// import Swal from "sweetalert2";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { apiRequest } from "../../apiService/allApi";
// import Rightcontainer from "../Components/Rightcontainer";

// // Lucide React Icons
// import {
//   User,
//   Pencil,
//   CheckCircle2,
//   Phone,
//   Mail,
//   ShieldCheck,
//   Award,
//   Swords,
//   Coins,
//   LogOut,
//   Sparkles,
//   ChevronRight,
//   Upload,
//   Calendar,
//   FileText,
//   X
// } from "lucide-react";

// // Import layout & styles
// import "../css/layout.css";
// import css from "../css/Profile.module.css";
// import "../css/kyc.css";
// import "../css/Loader.css";
// // import "./Profile1.css";

// const Profile1 = ({ profile }) => {
//   // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
//   const translations = {
//     hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
//     en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
//   };

//   const { language } = useContext(LanguageContext);
//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const handleClose = () => setShow1(false);
//   const handleShow = () => setShow1(true);
//   const [referral, setCode] = useState("");
//   const [Id, setId] = useState(null);
//   const [msg, setMsg] = useState("");
//   const [portcss, setPortcss] = useState(css.active_tab);
//   const [portcss1, setPortcss1] = useState(css.inactive_tab);
//   const [holder_name, setHolder_name] = useState();
//   const [account_number, setAccount_number] = useState();
//   const [ifsc_code, setIfsc_code] = useState();
//   const [upi_id, setUpi_id] = useState();
//   const [isLoading, setIsloading] = useState(false);
//   const [showKyc, setShowKyc] = useState(false);
//   const [process1, setProcesss] = useState(false);

//   const udata = localStorage.getItem("udata");
//   const profileData = JSON.parse(udata);
//   const siteData = localStorage.getItem("sitSetting");
//   const SData = JSON.parse(siteData);

//   const handleCloseKyc = () => setShowKyc(false);
//   const handleShowKyc = () => setShowKyc(true);
//   const [inputOpen, setInputOpen] = useState(false);
//   const [Email, setEmail] = useState(null);
//   const toggleInput = () => setInputOpen(!inputOpen);
//   const history = useHistory();

//   // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
//   const logout = async () => {
//     localStorage.clear();
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await apiRequest(`me`, "GET", null, headers)
//       .then(() => { /* logic */ })
//       .catch((e) => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem("token");
//           window.location.reload();
//           history.push("/login");
//         }
//       });
//   };

//   const UpdateEmail = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Email != null) {
//       try {
//         const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
//         if (respone.data.status === false) {
//           Swal.fire({ title: respone.data.msg, icon: "error" });
//         } else {
//           setEmail(respone.data); setInputOpen(false);
//           Swal.fire({ title: respone.data.msg, icon: "success" });
//         }
//       } catch (error) {}
//     } else {
//       Swal.fire({ title: "Please enter your Email", icon: "error" });
//     }
//   };

//   const [Name, setName] = useState(null);
//   const UpdateProfile = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Name != null) {
//       const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
//       if (respone.data.status === false) {
//         Swal.fire({ title: respone.data.msg, icon: "error" });
//       } else {
//         setName(respone.data);
//         Swal.fire({ title: respone.data.msg, icon: "success" });
//       }
//     }
//   };

//   const [total, setTotal] = useState();
//   const TotalGame = async () => {
//     let access_token = localStorage.getItem("token");
//     let userId = localStorage.getItem("userId");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
//       if (res.data) setTotal(res.data);
//     } catch (e) {}
//   };

//   const Result = async (file) => {
//     if (file) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const formData = new FormData();
//       formData.append("avatar", file);
//       await apiRequest(`users/me/avatar`, "POST", formData, headers);
//     }
//   };

//   const Kyc = () => setShowKyc(true);

//   const [AadharNum, setAadharNum] = useState("");
//   const [userAdharData, setUserAdharData] = useState("");
//   const handleAdharChnage = (e) => setAadharNum(e.target.value);

//   const AdharNumber = async (e) => {
//     setIsloading(true); e.preventDefault();
//     if (/^[0-9]{12}$/.test(AadharNum)) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const data = { aadharNumber: AadharNum };
//       try {
//         const res = await apiRequest("aadharcard-auto", "POST", data, headers);
//         setUserAdharData(res?.data);
//         setIsloading(false);
//         if (res.data.status === false) setMsg(res?.data?.msg);
//         else setMsg(res?.data?.data?.message);
//       } catch (error) { console.log(error); }
//     } else {
//       Swal.fire({ icon: "error", title: "Invalid Document Number", text: "12-digit number required" });
//       setIsloading(false);
//     }
//   };

//   const [AadharOtp, setAadharOtp] = useState("");
//   const [isLoading1, setIsloading1] = useState(false);
//   const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

//   const AdharOtpFunc = async (e) => {
//     setIsloading1(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
//     try {
//       const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
//       setIsloading1(false);
//       if (res.data.status === false) setMsg(res.data?.msg);
//       else window.location.reload();
//     } catch (e) { console.log(e); }
//   };

//   let aadharProcess = useRef(false);
//   const [Names, setNames] = useState("");
//   const [DOB, setDob] = useState("");
//   const [frontLoaded, setFrontLoaded] = useState(null);
//   const [backLoaded, setBackLoaded] = useState(null);

//   const handleSubmitdata = async (e) => {
//     e.preventDefault();
//     if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
//       alert("All fields required"); return;
//     }
//     if (aadharProcess.current === false) {
//       setProcesss(true); aadharProcess.current = true;
//       const formData = new FormData();
//       formData.append("Name", Names); formData.append("DOB", DOB);
//       formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
//       formData.append("Number", AadharNum); formData.append("Email", Email);
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const res = await apiRequest(`aadharcard`, "POST", formData, headers);
//       if (res.data.status === false) {
//         Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
//       } else {
//         Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
//         history.push("/Profile");
//       }
//       aadharProcess.current = false; setProcesss(false);
//     }
//   };

//   useEffect(() => { TotalGame(); }, []);

//   const [isValidEmail, setIsValidEmail] = useState(true);
//   const handleEmailChange = (e) => {
//     const newEmail = e.target.value;
//     setEmail(newEmail);
//     const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
//     setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
//   };

//   return (
//     <>
//       <div className="leftContainer dark_profile_wrapper mt-5 pt-5">
//         {/* Ambient Glowing Background Elements */}
//         <div className="profile-ambient glow-1"></div>
//         <div className="profile-ambient glow-2"></div>
//         <div className="profile-ambient glow-3"></div>

//         <div className="profile_main_container mb-5">

//           {/* 1. Header Profile Banner Card */}
//           <div className="profile_header_card">
//             <div className="header_top_badge">
//               <Sparkles size={14} className="sparkle_icon_spin" />
//               <span>Player Profile</span>
//             </div>

//             <div className="avatar_wrapper">
//               <label style={{ cursor: "pointer" }} className="avatar_label">
//                 <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
//                 <img
//                   src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar1.png"}
//                   alt="User Avatar"
//                   className="profile_avatar_img"
//                 />
//                 <div className="avatar_edit_overlay">
//                   <Pencil size={14} />
//                 </div>
//               </label>
//             </div>

//             <div className="profile_name_wrapper">
//               {portcss === css.active_tab ? (
//                 <div className="d-flex align-items-center justify-content-center">
//                   <span className="profile_username">{profile?.Name || "Player"}</span>
//                   <button 
//                     className="edit_pencil_btn ms-2"
//                     onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
//                   >
//                     <Pencil size={14} />
//                   </button>
//                 </div>
//               ) : (
//                 <div className="d-flex align-items-center justify-content-center">
//                   <input
//                     type="text"
//                     className="edit_name_input_dark"
//                     value={Name || ""}
//                     placeholder={profile?.Name || "Enter Name"}
//                     onChange={(e) => setName(e.target.value)}
//                   />
//                   <button className="btn_save_name_dark ms-2" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
//                     <CheckCircle2 size={18} />
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Section Heading: Complete Profile */}
//           <div className="section_header_label">Account Details</div>

//           {/* 2. Mobile Number Card */}
//           <div className="info_card_dark">
//             <div className="info_left">
//               <div className="info_icon_box phone_bg">
//                 <Phone size={20} />
//               </div>
//               <div className="info_details">
//                 <span className="info_title">Mobile Number</span>
//                 <span className="info_value">{profile?.Phone || "N/A"}</span>
//               </div>
//             </div>
//             <span className="verified_status_chip">Active</span>
//           </div>

//           {/* 3. Email Address Card */}
//           <div className="info_card_dark align-items-center justify-content-between">
//             <div className="info_left">
//               <div className="info_icon_box mail_bg">
//                 <Mail size={20} />
//               </div>
//               <div className="info_details">
//                 <span className="info_title">Email Address</span>
//                 <span className="info_value">{profile?.Email || "Not Updated"}</span>
//               </div>
//             </div>
//             <button className="edit_pencil_badge" onClick={toggleInput}>
//               <Pencil size={14} />
//             </button>
//           </div>

//           {/* Expandable Email Input */}
//           {inputOpen && (
//             <div className="email_update_box_dark animate_slide_down">
//               <input
//                 type="email"
//                 className="modern_input_dark"
//                 placeholder="Enter email address"
//                 value={Email || ""}
//                 onChange={handleEmailChange}
//               />
//               <button className="btn_update_email_dark mt-2 w-100" onClick={UpdateEmail}>Update Email</button>
//             </div>
//           )}

//           {/* 4. Large Pill Button: KYC Verification */}
//           <div className="kyc_button_banner" onClick={Kyc}>
//             <div className="kyc_left">
//               <div className="kyc_icon_wrapper">
//                 <ShieldCheck size={22} />
//               </div>
//               <span className="kyc_button_text">
//                 {profile?.verified === "verified" ? "KYC VERIFIED" : "KYC VERIFICATION"}
//               </span>
//             </div>
//             <ChevronRight size={20} className="kyc_arrow" />
//           </div>

//           {/* Section Heading: Other Details */}
//           <div className="section_header_label">Performance Overview</div>

//           {/* 5. Three Colored Stats Cards */}
//           <div className="other_details_grid">
//             {/* Referral Earning (Orange Gradient) */}
//             <div className="stat_card_block orange_gradient">
//               <div className="stat_icon_badge">
//                 <Award size={18} />
//               </div>
//               <span className="stat_card_title">Referral Earning</span>
//               <span className="stat_card_value">₹{String(profile?.referral_earning?.stringValue ?? "0")}</span>
//             </div>

//             {/* Battle Played (Cyan Gradient) */}
//             <div className="stat_card_block cyan_gradient">
//               <div className="stat_icon_badge">
//                 <Swords size={18} />
//               </div>
//               <span className="stat_card_title">{translations[language].game}</span>
//               <span className="stat_card_value">{String(total?.stringValue ?? total ?? "0")}</span>
//             </div>

//             {/* Coin Won (Purple/Gold Gradient) */}
//             <div className="stat_card_block purple_gradient">
//               <div className="stat_icon_badge">
//                 <Coins size={18} />
//               </div>
//               <span className="stat_card_title">{translations[language].Win}</span>
//               <span className="stat_card_value">₹{String(profile?.wonAmount?.stringValue ?? "0")}</span>
//             </div>
//           </div>

//           {/* 6. Log Out Button */}
//           <div className="logout_btn_wrapper text-center my-4">
//             <button className="logout_button_dark" onClick={logout}>
//               <LogOut size={18} />
//               <span>Log Out</span>
//             </button>
//           </div>

//         </div>

//         {/* Modal - Ultra-Premium Light Themed
//         <Modal show={showKyc} onHide={handleCloseKyc} centered className="dark_modal">
//           <Modal.Header closeButton className="dark_modal_header border-0">
//             <Modal.Title className="modal_title_text">
//               <ShieldCheck size={20} className="me-2 text-emerald" /> Identity Verification
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="pt-0">
//             <ul className="nav nav-pills modern_tabs mb-3" id="kycTab" role="tablist">
//               {SData.onlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online KYC</button>
//                 </li>
//               )}
//               {SData.offlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline">Offline KYC</button>
//                 </li>
//               )}
//             </ul>

//             <div className="tab-content mt-3">
//               {SData.onlineKYC && (
//                 <div className="tab-pane fade show active" id="online">
//                   <div className="form-group mb-3">
//                     <label className="input_label_dark">Document Identification Number</label>
//                     <input type="number" className="modern_input_dark" value={AadharNum} onChange={handleAdharChnage} placeholder="12 Digit ID Number" />
//                     {msg && <p className="text-danger small mt-1 mb-0">{msg}</p>}
//                   </div>
//                   {isLoading ? (
//                     <div className="text-center py-2"><img src='/images/LandingPage_img/loader1.gif' width="36" alt="Loading..." /></div>
//                   ) : (
//                     userAdharData?.data?.status !== "SUCCESS" && <button className="btn_premium_modal w-100" onClick={AdharNumber}>Send OTP</button>
//                   )}
//                   {userAdharData?.data?.status === "SUCCESS" && (
//                     <div className="mt-3">
//                       <label className="input_label_dark">Verification OTP</label>
//                       <input type="number" className="modern_input_dark" value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter 6 digit OTP" />
//                       <button className="btn_premium_modal w-100 mt-3" onClick={AdharOtpFunc}>Submit & Verify</button>
//                     </div>
//                   )}
//                 </div>
//               )}
//               {SData.offlineKYC && (
//                 <div className="tab-pane fade" id="offline">
//                   <div className="mb-2">
//                     <label className="input_label_dark">Full Name</label>
//                     <input type="text" className="modern_input_dark" placeholder="Name as per government ID" value={Names} onChange={(e) => setNames(e.target.value)} />
//                   </div>
//                   <div className="mb-2">
//                     <label className="input_label_dark">Identification Number</label>
//                     <input type="text" className="modern_input_dark" placeholder="12 Digit ID Number" value={AadharNum} onChange={handleAdharChnage} />
//                   </div>
//                   <div className="mb-3">
//                     <label className="input_label_dark">Date of Birth</label>
//                     <input type="date" className="modern_input_dark" value={DOB} onChange={(e) => setDob(e.target.value)} />
//                   </div>
//                   <div className="file_upload_area mb-2">
//                     <label>Upload Front Photo</label>
//                     <input type="file" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <div className="file_upload_area mb-3">
//                     <label>Upload Back Photo</label>
//                     <input type="file" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <button className="btn_premium_modal w-100" onClick={handleSubmitdata}>Submit Verification</button>
//                 </div>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal> */}
//         {/* Modal - Ultra-Premium Emerald & Cyan Light Theme */}
// <Modal show={showKyc} onHide={handleCloseKyc} centered className="kyc_modal_custom">
//   <Modal.Header closeButton className="kyc_modal_header border-0">
//     <Modal.Title className="kyc_modal_title">
//       <ShieldCheck size={22} className="title_shield_icon" /> Identity Verification
//     </Modal.Title>
//   </Modal.Header>

//   <Modal.Body className="kyc_modal_body">
//     {/* Navigation Tabs */}
//     <ul className="nav nav-pills modern_kyc_tabs mb-3" id="kycTab" role="tablist">
//       {SData.onlineKYC && (
//         <li className="nav-item flex-fill">
//           <button
//             className="nav-link active w-100"
//             id="online-tab"
//             data-bs-toggle="tab"
//             data-bs-target="#online"
//             type="button"
//           >
//             Online KYC
//           </button>
//         </li>
//       )}
//       {SData.offlineKYC && (
//         <li className="nav-item flex-fill">
//           <button
//             className="nav-link w-100"
//             id="offline-tab"
//             data-bs-toggle="tab"
//             data-bs-target="#offline"
//             type="button"
//           >
//             Offline KYC
//           </button>
//         </li>
//       )}
//     </ul>

//     {/* Tab Contents */}
//     <div className="tab-content kyc_tab_content">
//       {/* ONLINE KYC TAB */}
//       {SData.onlineKYC && (
//         <div className="tab-pane fade show active" id="online">
//           <div className="kyc_form_group mb-3">
//             <label className="kyc_input_label">
//               <FileText size={15} className="label_icon" /> Document Identification Number
//             </label>
//             <div className="kyc_input_wrapper">
//               <input
//                 type="number"
//                 className="kyc_input_field"
//                 value={AadharNum}
//                 onChange={handleAdharChnage}
//                 placeholder="12 Digit ID Number"
//               />
//             </div>
//             {msg && <p className="kyc_error_text mt-1 mb-0">{msg}</p>}
//           </div>

//           {isLoading ? (
//             <div className="text-center py-3">
//               <img
//                 src="/images/LandingPage_img/loader1.gif"
//                 width="36"
//                 alt="Loading..."
//               />
//             </div>
//           ) : (
//             userAdharData?.data?.status !== "SUCCESS" && (
//               <button
//                 type="button"
//                 className="btn_kyc_primary w-100"
//                 onClick={AdharNumber}
//               >
//                 Send OTP
//               </button>
//             )
//           )}

//           {userAdharData?.data?.status === "SUCCESS" && (
//             <div className="mt-3 animate_slide_down">
//               <div className="kyc_form_group mb-3">
//                 <label className="kyc_input_label">
//                   <ShieldCheck size={15} className="label_icon" /> Verification OTP
//                 </label>
//                 <div className="kyc_input_wrapper">
//                   <input
//                     type="number"
//                     className="kyc_input_field"
//                     value={AadharOtp}
//                     onChange={handleAdharOtpChnage}
//                     placeholder="Enter 6 digit OTP"
//                   />
//                 </div>
//               </div>
//               <button
//                 type="button"
//                 className="btn_kyc_primary w-100"
//                 onClick={AdharOtpFunc}
//               >
//                 Submit & Verify
//               </button>
//             </div>
//           )}
//         </div>
//       )}

//       {/* OFFLINE KYC TAB */}
//       {SData.offlineKYC && (
//         <div className="tab-pane fade mt-4" id="offline">
//           <form className="offline_kyc_form" onSubmit={handleSubmitdata}>
//             {/* Full Name */}
//             <div className="kyc_form_group mb-3">
//               <label className="kyc_input_label">
//                 <User size={15} className="label_icon" /> Full Name
//               </label>
//               <div className="kyc_input_wrapper">
//                 <input
//                   type="text"
//                   className="kyc_input_field"
//                   placeholder="Name as per government ID"
//                   value={Names}
//                   onChange={(e) => setNames(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>

//             {/* Identification Number */}
//             <div className="kyc_form_group mb-3">
//               <label className="kyc_input_label">
//                 <FileText size={15} className="label_icon" /> Identification Number
//               </label>
//               <div className="kyc_input_wrapper">
//                 <input
//                   type="text"
//                   className="kyc_input_field"
//                   placeholder="12 Digit ID Number"
//                   value={AadharNum}
//                   onChange={handleAdharChnage}
//                   maxLength={12}
//                   required
//                 />
//               </div>
//             </div>

//             {/* Date of Birth */}
//             <div className="kyc_form_group mb-3">
//               <label className="kyc_input_label">
//                 <Calendar size={15} className="label_icon" /> Date of Birth
//               </label>
//               <div className="kyc_input_wrapper">
//                 <input
//                   type="date"
//                   className="kyc_input_field date_picker_custom"
//                   value={DOB}
//                   onChange={(e) => setDob(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>

//             {/* File Upload Grid */}
//             <div className="kyc_upload_grid mb-3">
//               {/* Front Photo */}
//               <div className={`kyc_file_card ${frontLoaded ? "file_uploaded" : ""}`}>
//                 <label className="kyc_file_label">
//                   <input
//                     type="file"
//                     onChange={(e) => setFrontLoaded(e.target.files)}
//                     accept="image/*"
//                     className="kyc_file_input_hidden"
//                     required
//                   />
//                   <div className="kyc_file_box_content">
//                     {frontLoaded && frontLoaded[0] ? (
//                       <div className="file_info_state">
//                         <CheckCircle2 size={22} className="text_emerald" />
//                         <span className="file_name_truncated">{frontLoaded[0].name}</span>
//                         <span className="file_badge_action">Change Front</span>
//                       </div>
//                     ) : (
//                       <div className="file_placeholder_state">
//                         <Upload size={22} className="upload_icon_anim" />
//                         <span className="upload_title">Front Photo</span>
//                         <span className="upload_sub_text">Click to select</span>
//                       </div>
//                     )}
//                   </div>
//                 </label>
//               </div>

//               {/* Back Photo */}
//               <div className={`kyc_file_card ${backLoaded ? "file_uploaded" : ""}`}>
//                 <label className="kyc_file_label">
//                   <input
//                     type="file"
//                     onChange={(e) => setBackLoaded(e.target.files)}
//                     accept="image/*"
//                     className="kyc_file_input_hidden"
//                     required
//                   />
//                   <div className="kyc_file_box_content">
//                     {backLoaded && backLoaded[0] ? (
//                       <div className="file_info_state">
//                         <CheckCircle2 size={22} className="text_emerald" />
//                         <span className="file_name_truncated">{backLoaded[0].name}</span>
//                         <span className="file_badge_action">Change Back</span>
//                       </div>
//                     ) : (
//                       <div className="file_placeholder_state">
//                         <Upload size={22} className="upload_icon_anim" />
//                         <span className="upload_title">Back Photo</span>
//                         <span className="upload_sub_text">Click to select</span>
//                       </div>
//                     )}
//                   </div>
//                 </label>
//               </div>
//             </div>

//             {/* Submit Verification Button */}
//             <button type="submit" className="btn_kyc_primary w-100">
//               <ShieldCheck size={18} /> Submit Verification
//             </button>
//           </form>
//         </div>
//       )}
//     </div>
//   </Modal.Body>
// </Modal>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </>
//   );
// };

// export default Profile1;




import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Modal from "react-bootstrap/Modal";
import { LanguageContext } from "../Components/LanguageContext";
import { apiRequest } from "../../apiService/allApi";
import Rightcontainer from "../Components/Rightcontainer";

// Lucide React Icons
import {
  User,
  Pencil,
  CheckCircle2,
  Phone,
  Mail,
  ShieldCheck,
  Trophy,
  Swords,
  Share2,
  LogOut,
  ChevronRight,
  Upload,
  Calendar,
  FileText,
  History as HistoryIcon,
  Headphones,
  Gift,
  Zap,
  Smartphone,
  KeyRound,
  Sparkles,
  Lock,
  X
} from "lucide-react";

import "../css/Profile.css";

const Profile1 = ({ profile }) => {
  const translations = {
    hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
    en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
  };

  const { language } = useContext(LanguageContext);
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const [showKyc, setShowKyc] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData) || {};

  const handleCloseKyc = () => setShowKyc(false);
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState(null);
  const toggleInput = () => setInputOpen(!inputOpen);
  const history = useHistory();

  const [portcss, setPortcss] = useState(true);

  // --- LOGOUT FUNCTION ---
  const logout = async () => {
    localStorage.clear();
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await apiRequest(`me`, "GET", null, headers)
      .then(() => {})
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  // --- UPDATE EMAIL ---
  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Email != null) {
      try {
        const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
        if (respone.data.status === false) {
          Swal.fire({ title: respone.data.msg, icon: "error" });
        } else {
          setEmail(respone.data); setInputOpen(false);
          Swal.fire({ title: respone.data.msg, icon: "success" });
        }
      } catch (error) {}
    } else {
      Swal.fire({ title: "Please enter your Email", icon: "error" });
    }
  };

  // --- UPDATE PROFILE NAME ---
  const [Name, setName] = useState(null);
  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Name != null) {
      const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
      if (respone.data.status === false) {
        Swal.fire({ title: respone.data.msg, icon: "error" });
      } else {
        setName(respone.data);
        Swal.fire({ title: respone.data.msg, icon: "success" });
      }
    }
  };

  // --- TOTAL GAMES ---
  const [total, setTotal] = useState();
  const TotalGame = async () => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
      if (res.data) setTotal(res.data);
    } catch (e) {}
  };

  // --- AVATAR UPLOAD ---
  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("avatar", file);
      await apiRequest(`users/me/avatar`, "POST", formData, headers);
    }
  };

  const Kyc = () => setShowKyc(true);

  // --- ONLINE KYC ---
  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const handleAdharChnage = (e) => setAadharNum(e.target.value);

  const AdharNumber = async (e) => {
    setIsloading(true); e.preventDefault();
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const data = { aadharNumber: AadharNum };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);
        if (res.data.status === false) setMsg(res?.data?.msg);
        else setMsg(res?.data?.data?.message);
      } catch (error) { console.log(error); }
    } else {
      Swal.fire({ icon: "error", title: "Invalid Document Number", text: "12-digit number required" });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [isLoading1, setIsloading1] = useState(false);
  const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

  const AdharOtpFunc = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
    try {
      const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
      setIsloading1(false);
      if (res.data.status === false) setMsg(res.data?.msg);
      else window.location.reload();
    } catch (e) { console.log(e); }
  };

  // --- OFFLINE KYC ---
  let aadharProcess = useRef(false);
  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("All fields required"); return;
    }
    if (aadharProcess.current === false) {
      setProcesss(true); aadharProcess.current = true;
      const formData = new FormData();
      formData.append("Name", Names); formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum); formData.append("Email", Email);
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
      } else {
        Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
        history.push("/Profile");
      }
      aadharProcess.current = false; setProcesss(false);
    }
  };

  useEffect(() => { TotalGame(); }, []);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
  };

  const getInitials = (name) => {
    if (!name) return "P";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
  };

  return (
    <>
      <div className="ce-profile-wrapper leftContainer mt-5 pt-5">
        <div className="ce-profile-container mb-5">

          {/* 1. Main Profile Card */}
          <div className="ce-profile-hero-card">
            <div className="ce-avatar-wrapper">
              <label style={{ cursor: "pointer" }} className="ce-avatar-label">
                <input
                  type="file"
                  className="d-none"
                  accept="image/*"
                  onChange={(e) => Result(e.target.files[0])}
                />
                {profileData?.avatar ? (
                  <img
                    src={`${baseUrl}/${profileData.avatar}`}
                    alt="User Avatar"
                    className="ce-avatar-img"
                  />
                ) : (
                  <div className="ce-avatar-initials">
                    {getInitials(profile?.Name)}
                  </div>
                )}
                <div className="ce-avatar-edit-overlay">
                  <Pencil size={12} />
                </div>
              </label>
            </div>

            <div className="ce-profile-name-box">
              {portcss ? (
                <div className="ce-name-display-row">
                  <h1 className="ce-username">{profile?.Name || "Player"}</h1>
                </div>
              ) : (
                <div className="ce-name-edit-row">
                  <input
                    type="text"
                    className="ce-input-field ce-name-input"
                    value={Name || ""}
                    placeholder={profile?.Name || "Enter Name"}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <button
                    className="ce-save-btn"
                    onClick={() => {
                      setPortcss(true);
                      UpdateProfile();
                    }}
                  >
                    <CheckCircle2 size={16} />
                  </button>
                </div>
              )}

              <p className="ce-user-phone"><Phone size={13} className="ce-inline-icon" /> +91 {profile?.Phone || "N/A"}</p>
            </div>

            <button
              className="ce-edit-profile-btn"
              onClick={() => setPortcss(!portcss)}
            >
              <Pencil size={14} />
              <span>{portcss ? "Edit profile" : "Cancel"}</span>
            </button>

            <div className="ce-kyc-inner-banner" onClick={Kyc}>
              <div className="ce-kyc-banner-left">
                <div className="ce-kyc-icon-badge">
                  <ShieldCheck size={18} />
                </div>
                <div className="ce-kyc-banner-text">
                  <h3>Secure your account</h3>
                  <p>{profile?.verified === "verified" ? "KYC Completed" : "Complete KYC to withdraw"}</p>
                </div>
              </div>

              <button className="ce-kyc-action-pill">
                <span>{profile?.verified === "verified" ? "VERIFIED" : "KYC"}</span>
                <ChevronRight size={14} />
              </button>
            </div>
          </div>

          {/* 2. Top Stats Row */}
          <div className="ce-stats-bar-grid">
            <div className="ce-stat-box">
              <div className="ce-stat-icon-wrapper">
                <Trophy size={18} />
              </div>
              <span className="ce-stat-title">WON</span>
              <span className="ce-stat-val">₹{String(profile?.wonAmount?.stringValue ?? profile?.wonAmount ?? "0")}</span>
            </div>

            <div className="ce-stat-box">
              <div className="ce-stat-icon-wrapper">
                <Swords size={18} />
              </div>
              <span className="ce-stat-title">GAMES</span>
              <span className="ce-stat-val">{String(total?.stringValue ?? total ?? "0")}</span>
            </div>

            <div className="ce-stat-box">
              <div className="ce-stat-icon-wrapper">
                <Share2 size={18} />
              </div>
              <span className="ce-stat-title">REFS</span>
              <span className="ce-stat-val">{profile?.referral_user?.length || 0}</span>
            </div>
          </div>

          <div className="ce-section-header">
            <Zap size={14} className="ce-emerald-icon" />
            <span>QUICK ACTIONS</span>
          </div>

          {/* 3. Quick Actions 2x2 Grid */}
          <div className="ce-quick-grid">
            <div className="ce-quick-card" onClick={Kyc}>
              <div className="ce-quick-icon-box">
                <ShieldCheck size={20} />
              </div>
              <div className="ce-quick-info">
                <h3>Complete KYC</h3>
                <p>Verify identity</p>
              </div>
            </div>

            <Link to="/history" className="ce-quick-card">
              <div className="ce-quick-icon-box">
                <HistoryIcon size={20} />
              </div>
              <div className="ce-quick-info">
                <h3>History</h3>
                <p>Battles & money</p>
              </div>
            </Link>

            <Link to="/support" className="ce-quick-card">
              <div className="ce-quick-icon-box">
                <Headphones size={20} />
              </div>
              <div className="ce-quick-info">
                <h3>Support</h3>
                <p>Help & chat</p>
              </div>
            </Link>

            <Link to="/refer" className="ce-quick-card">
              <div className="ce-quick-icon-box">
                <Gift size={20} />
              </div>
              <div className="ce-quick-info">
                <h3>Referral Redeem</h3>
                <p>Convert earnings</p>
              </div>
            </Link>
          </div>

          {/* 4. Additional Email Card Section */}
          <div className="ce-account-details-card">
            <div className="ce-detail-row">
              <div className="ce-detail-left">
                <div className="ce-detail-icon">
                  <Mail size={18} />
                </div>
                <div className="ce-detail-text">
                  <span className="ce-detail-label">Email Address</span>
                  <span className="ce-detail-val">{profile?.Email || "Not Updated"}</span>
                </div>
              </div>
              <button className="ce-detail-edit-btn" onClick={toggleInput}>
                <Pencil size={14} />
              </button>
            </div>

            {inputOpen && (
              <div className="ce-email-expand-box">
                <input
                  type="email"
                  className="ce-input-field"
                  placeholder="Enter email address"
                  value={Email || ""}
                  onChange={handleEmailChange}
                />
                <button className="ce-submit-btn" onClick={UpdateEmail}>
                  Update Email
                </button>
              </div>
            )}
          </div>

          {/* 5. Log Out Button */}
          <div className="ce-logout-wrapper">
            <button className="ce-logout-btn" onClick={logout}>
              <LogOut size={16} />
              <span>Log Out</span>
            </button>
          </div>

        </div>

        {/* Modal - Redesigned KYC Verification Dialog */}
        <Modal show={showKyc} onHide={handleCloseKyc} centered className="ce-kyc-modal-dialog">
          <Modal.Body className="ce-kyc-modal-content">
            <button className="ce-modal-close-btn" onClick={handleCloseKyc}>
              <X size={16} />
            </button>

            {/* Modal Header Badge */}
            <div className="ce-kyc-header-row">
              <div className="ce-kyc-avatar-icon">
                <Smartphone size={22} />
              </div>
              <div className="ce-kyc-header-text">
                <span className="ce-kyc-tag">INSTANT VERIFY</span>
                <h2 className="ce-kyc-modal-title">INSTANT AADHAAR VERIFY</h2>
                <p className="ce-kyc-modal-sub">OTP on linked mobile — no uploads</p>
              </div>
            </div>

            {/* Step Stepper Line */}
            <div className="ce-kyc-stepper">
              <div className="ce-step-pill active">
                <Smartphone size={14} />
                <span>Aadhaar</span>
              </div>
              <div className="ce-step-connector"></div>
              <div className={`ce-step-pill ${userAdharData?.data?.status === "SUCCESS" ? "active" : ""}`}>
                <KeyRound size={14} />
                <span>OTP</span>
              </div>
            </div>

            {/* Navigation Tabs */}
            <ul className="nav nav-pills ce-kyc-nav-tabs" id="kycTab" role="tablist">
              {SData.onlineKYC && (
                <li className="nav-item flex-fill">
                  <button
                    className="nav-link active w-100"
                    id="online-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#online"
                    type="button"
                  >
                    Online KYC
                  </button>
                </li>
              )}
              {SData.offlineKYC && (
                <li className="nav-item flex-fill">
                  <button
                    className="nav-link w-100"
                    id="offline-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#offline"
                    type="button"
                  >
                    Offline KYC
                  </button>
                </li>
              )}
            </ul>

            {/* Tab Content */}
            <div className="tab-content ce-kyc-tab-body">
              {/* ONLINE KYC TAB */}
              {SData.onlineKYC && (
                <div className="tab-pane fade show active" id="online">
                  <div className="ce-kyc-feature-box">
                    <Zap size={18} className="ce-feature-icon" />
                    <div>
                      <h4>Live OTP verification</h4>
                      <p>Instant approval — no document upload needed</p>
                    </div>
                  </div>

                  <div className="ce-kyc-field-group">
                    <label className="ce-kyc-field-label">AADHAAR NUMBER</label>
                    <div className="ce-kyc-input-box">
                      <input
                        type="number"
                        className="ce-kyc-input"
                        value={AadharNum}
                        onChange={handleAdharChnage}
                        placeholder="12-digit Aadhaar"
                      />
                    </div>
                    <span className="ce-kyc-field-note">
                      OTP goes to the mobile number linked with your Aadhaar.
                    </span>
                    {msg && <p className="ce-kyc-error-msg">{msg}</p>}
                  </div>

                  {isLoading ? (
                    <div className="text-center py-3">
                      <img src="/images/LandingPage_img/loader1.gif" width="36" alt="Loading..." />
                    </div>
                  ) : (
                    userAdharData?.data?.status !== "SUCCESS" && (
                      <button
                        type="button"
                        className="ce-kyc-submit-btn"
                        onClick={AdharNumber}
                      >
                        <Smartphone size={18} />
                        <span>SEND AADHAAR OTP</span>
                      </button>
                    )
                  )}

                  {userAdharData?.data?.status === "SUCCESS" && (
                    <div className="ce-kyc-field-group mt-3 animate-slide-up">
                      <label className="ce-kyc-field-label">VERIFICATION OTP</label>
                      <div className="ce-kyc-input-box">
                        <input
                          type="number"
                          className="ce-kyc-input"
                          value={AadharOtp}
                          onChange={handleAdharOtpChnage}
                          placeholder="Enter 6-digit OTP"
                        />
                      </div>
                      <button
                        type="button"
                        className="ce-kyc-submit-btn mt-3"
                        onClick={AdharOtpFunc}
                      >
                        <Lock size={18} />
                        <span>SUBMIT & VERIFY</span>
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* OFFLINE KYC TAB */}
              {SData.offlineKYC && (
                <div className="tab-pane fade" id="offline">
                  <form className="ce-offline-form" onSubmit={handleSubmitdata}>
                    <div className="ce-kyc-field-group">
                      <label className="ce-kyc-field-label">FULL NAME</label>
                      <div className="ce-kyc-input-box">
                        <input
                          type="text"
                          className="ce-kyc-input"
                          placeholder="Name as per ID"
                          value={Names}
                          onChange={(e) => setNames(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="ce-kyc-field-group">
                      <label className="ce-kyc-field-label">ID NUMBER</label>
                      <div className="ce-kyc-input-box">
                        <input
                          type="text"
                          className="ce-kyc-input"
                          placeholder="12-digit Number"
                          value={AadharNum}
                          onChange={handleAdharChnage}
                          maxLength={12}
                          required
                        />
                      </div>
                    </div>

                    <div className="ce-kyc-field-group">
                      <label className="ce-kyc-field-label">DATE OF BIRTH</label>
                      <div className="ce-kyc-input-box">
                        <input
                          type="date"
                          className="ce-kyc-input date-input"
                          value={DOB}
                          onChange={(e) => setDob(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="ce-upload-grid">
                      <div className={`ce-upload-card ${frontLoaded ? "uploaded" : ""}`}>
                        <label className="ce-upload-label">
                          <input
                            type="file"
                            onChange={(e) => setFrontLoaded(e.target.files)}
                            accept="image/*"
                            className="d-none"
                            required
                          />
                          <Upload size={18} />
                          <span>{frontLoaded && frontLoaded[0] ? frontLoaded[0].name : "Front Photo"}</span>
                        </label>
                      </div>

                      <div className={`ce-upload-card ${backLoaded ? "uploaded" : ""}`}>
                        <label className="ce-upload-label">
                          <input
                            type="file"
                            onChange={(e) => setBackLoaded(e.target.files)}
                            accept="image/*"
                            className="d-none"
                            required
                          />
                          <Upload size={18} />
                          <span>{backLoaded && backLoaded[0] ? backLoaded[0].name : "Back Photo"}</span>
                        </label>
                      </div>
                    </div>

                    <button type="submit" className="ce-kyc-submit-btn">
                      <ShieldCheck size={18} />
                      <span>SUBMIT VERIFICATION</span>
                    </button>
                  </form>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>

      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
};

export default Profile1;